
"use strict";
import './assets'
//import external node
import '../node_modules/jquery/dist/jquery.min.js'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle'
import './js/vendors/slick-carouse.js'
 
//import internal library vendors
//import start script js
import './js/script.js'







